import { formatPenaltyDays, humanizePenaltyReason } from "./penaltyFormat";
import { calendarMonthYearFromDate } from "./fillMonthPunchDays";

export { humanizePenaltyReason };

const PENALTY_TYPE_LABELS = {
  FINANCIAL_PENALTY: "جزاء مالي",
  WARNING: "إنذار",
  "جزاء مالي": "جزاء مالي",
  إنذار: "إنذار",
};

const LEAVE_TYPE_LABELS = {
  ANNUAL: "إجازة اعتيادية",
  SICK: "إجازة مرضية",
  CASUAL: "إجازة عارضة",
  UNPAID: "إجازة على الحساب الخاص",
  COMPENSATORY: "إجازة تعويضية",
  SPECIAL: "إجازة ممنوحة",
};

const APPEAL_KIND_LABELS = {
  penalty: "جزاء",
  request: "طلب مرفوض",
  advance: "سلفة",
  leave: "إجازة",
};

function toNumber(value) {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function formatAppealDate(value) {
  if (!value) return "";
  const raw = typeof value === "string" ? value.slice(0, 10) : null;
  const date = raw
    ? new Date(`${raw}T00:00:00`)
    : value instanceof Date
      ? value
      : new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString("ar-EG", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

function formatAmount(amount) {
  const n = toNumber(amount);
  if (n == null) return "";
  return `${n.toLocaleString("ar-EG")} ج.م`;
}

function fromPenalty(penalty, kind = "penalty") {
  const typeKey = penalty.typeLabel || penalty.type || penalty.backendType;
  const days = toNumber(penalty.days);
  const amount = toNumber(penalty.amount);
  const date = penalty.effectiveDate || penalty.date || null;
  return {
    kind,
    typeLabel: PENALTY_TYPE_LABELS[typeKey] || typeKey || "جزاء",
    whatHappened: humanizePenaltyReason(penalty.reason),
    date,
    dateLabel: formatAppealDate(date),
    days,
    daysLabel: formatPenaltyDays(days),
    amount,
    amountLabel: formatAmount(amount),
    dateTo: null,
    dateToLabel: "",
  };
}

function fromSubject(subject, kind) {
  const days = toNumber(subject.days);
  const amount = toNumber(subject.amount);
  const date = subject.date || subject.effectiveDate || null;
  const dateTo = subject.dateTo || null;
  return {
    kind: subject.kind || kind,
    typeLabel:
      subject.typeLabel ||
      APPEAL_KIND_LABELS[subject.kind || kind] ||
      "تظلم",
    whatHappened: humanizePenaltyReason(subject.whatHappened || subject.reason),
    date,
    dateLabel: formatAppealDate(date),
    days,
    daysLabel: formatPenaltyDays(days),
    amount,
    amountLabel: formatAmount(amount),
    dateTo,
    dateToLabel: formatAppealDate(dateTo),
  };
}

/**
 * Resolves what the employee is appealing: type, what happened, and the day.
 * Prefers API `subject`, then embedded `penalty`, then a local penalties list.
 */
export function getAppealSubject(appeal, penalties = []) {
  if (!appeal) return null;

  if (
    appeal.subject &&
    (appeal.subject.typeLabel ||
      appeal.subject.whatHappened ||
      appeal.subject.date)
  ) {
    return fromSubject(appeal.subject, appeal.type);
  }

  if (appeal.penalty) {
    return fromPenalty(appeal.penalty, appeal.type);
  }

  if (appeal.penaltyId && penalties.length) {
    const pen = penalties.find(
      (p) => String(p.id) === String(appeal.penaltyId),
    );
    if (pen) return fromPenalty(pen, appeal.type);
  }

  return null;
}

export function getAppealKindLabel(type) {
  return APPEAL_KIND_LABELS[type] || type || "تظلم";
}

export function getAppealPunchMonth(appeal, penalties = []) {
  const subject = getAppealSubject(appeal, penalties);
  return calendarMonthYearFromDate(subject?.date || appeal?.submittedAt);
}

export { LEAVE_TYPE_LABELS, PENALTY_TYPE_LABELS };
